import { Box, Theme, Paper } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme:Theme) => ({
    card: {
        color: 'green !important',
        "&:hover": {
            backgroundColor: 'green',
            color: 'white !important',
            cursor: 'pointer',
        },
    },
    active: {
        backgroundColor: 'green !important',
        color: 'white  !important',
        cursor: 'pointer'
    },
    paper: {
        height: '160px'
    }
}));

export default function CategoryCard(props: any) {
    const classes = useStyles();
    return (
        <Paper elevation={2} className={`${classes.card} ${classes.paper} ${props.active ? classes.active : ''}`} >
            <Box display="flex" alignItems="center" justifyContent="center" flexDirection="column" width="100%" height="100%">
                {props.children}
            </Box>
        </Paper>
    );
}
